import {
  AfterViewInit,
  Component,
  ViewChild,
  Renderer2,
  RendererFactory2,
  ElementRef,
  Input,
  ViewRef,
  ChangeDetectionStrategy,
  NgZone,
} from "@angular/core";
import { default as vegaEmbed } from "vega-embed";

import { HsDialogContainerService } from "hslayers-ng";

@Component({
  selector: "chart-focus",
  templateUrl: "./chart-focus.component.html",
  styleUrls: ["./chart-focus.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartFocusComponent implements AfterViewInit {
  renderer: Renderer2;
  @ViewChild("svgContainer") svgContainer;
  @Input() data: any;

  chartTitle: string = null;
  viewRef: ViewRef;

  constructor(
    rendererFactory: RendererFactory2,
    public elementRef: ElementRef,
    public HsDialogContainerService: HsDialogContainerService,
    private zone: NgZone
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  cancel() {
    this.HsDialogContainerService.destroy(this);
  }

  /**
   * Adjust width and height of focused chart in 21:9 aspect ratio
   */
  setLayerDimensions(layer) {
    layer.width = document.documentElement.clientWidth / 2;
    layer.height = layer.width * 0.4285;
  }

  ngAfterViewInit(): void {
    const spec = JSON.parse(JSON.stringify(this.data.res.spec));
    let chartClicked;

    if (this.data.item.mark.name?.includes("agroInfoChart")) {
      // Extract dataset name from selected chart reference
      chartClicked = this.data.item.mark.name.split("_")[1];
    }

    if (chartClicked === "rect") {
      spec.hconcat.pop();
      spec.hconcat[0].height = document.documentElement.clientHeight / 2.5;
      spec.layer = [spec.hconcat[0]];
      delete spec.hconcat;
      this.setLayerDimensions(spec.layer[0]);
    } else {
      if (spec.hconcat.length > 1) {
        spec.hconcat.shift();
      }

      spec.hconcat[0].concat = spec.hconcat[0].concat.filter((i) => {
        return i.name.includes(chartClicked);
      });
      spec.layer = spec.hconcat[0].concat[0].layer;
      if (spec.hconcat[0].concat[0].encoding) {
        spec.encoding = spec.hconcat[0].concat[0].encoding;
      }
      if (spec.hconcat[0].concat[0].resolve) {
        spec.resolve = spec.hconcat[0].concat[0].resolve;
      }
      delete spec.hconcat;

      for (const layer of spec.layer) {
        this.setLayerDimensions(layer);
        if (layer.encoding.y?.field == "gdu") {
          delete layer.encoding.color.legend.labelLimit;
          layer.encoding.color.legend.labelFontSize = 20;
        }
      }
      spec.autosize = {
        type: "pad",
        contains: "padding",
        resize: true,
      };
    }
    setTimeout(() => {
      this.chartTitle = spec.layer[0].title.text;
    }, 0);

    // Render vega view
    try {
      this.zone.runOutsideAngular(() => {
        vegaEmbed(
          this.elementRef.nativeElement.querySelector(".zoomedChart"),
          spec,
          { renderer: "svg" }
        );
      });
    } catch (ex) {
      console.warn("Could not create vega chart:", ex);
    }
  }
}
